import { FormattedMessage } from "react-intl";

import InputItem from "../../../app/generic/form/inputItem";

const invoiceEmailName = "invoiceEmail",
  businessEmailName = "businessEmail",
  businessContactName = "businessContact",
  businessPhoneName = "businessPhone",
  trackingEmailName = "trackingEmail";

export const parseContactsForm = (values) => ({
  invoiceEmail: values[invoiceEmailName],
  businessEmail: values[businessEmailName],
  businessContact: values[businessContactName],
  businessPhone: values[businessPhoneName],
  trackingEmail: values[trackingEmailName],
});

export const parseInitialContactForm = (contacts) => {
  const values = {};
  if (contacts) {
    values[invoiceEmailName] = contacts.invoiceEmail;
    values[businessEmailName] = contacts.businessEmail;
    values[businessContactName] = contacts.businessContact;
    values[businessPhoneName] = contacts.businessPhone;
    values[trackingEmailName] = contacts.trackingEmail;
  }
  return values;
};

const Contacts = ({ formItemLayout }) => (
  <>
    <InputItem
      email
      required
      autoComplete="email"
      fieldName={invoiceEmailName}
      formItemLayout={formItemLayout}
      label={
        <FormattedMessage
          id="registration.contacts.email.invoice"
          defaultMessage="Email pro elektronickou fakturaci"
        />
      }
    />
    <InputItem
      email
      required
      autoComplete="email"
      fieldName={businessEmailName}
      formItemLayout={formItemLayout}
      label={
        <FormattedMessage
          id="registration.contacts.email.business"
          defaultMessage="Email pro obchodní sdělení"
        />
      }
    />
    <InputItem
      required
      autoComplete="name"
      fieldName={businessContactName}
      formItemLayout={formItemLayout}
      label={
        <FormattedMessage
          id="registration.contacts.contact.business"
          defaultMessage="Kontakt pro obchodní sdělení"
        />
      }
    />
    <InputItem
      required
      phoneNumber
      autoComplete="phone"
      fieldName={businessPhoneName}
      formItemLayout={formItemLayout}
      label={
        <FormattedMessage
          id="registration.contacts.phone.business"
          defaultMessage="Telefon pro obchodní sdělení"
        />
      }
    />
    <InputItem
      email
      required
      autoComplete="email"
      fieldName={trackingEmailName}
      formItemLayout={formItemLayout}
      label={
        <FormattedMessage
          id="registration.contacts.email.tracking"
          defaultMessage="Email pro tracking zásilek"
        />
      }
    />
  </>
);

export default Contacts;
